// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Login Page Layout ────────────────────────────────── */
.login-page-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

/* ── Left Panel ────────────────────────────────────────── */
.login-left-panel {
  width: 42%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 3rem;
}

.login-left-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  max-width: 400px;
  width: 100%;
  text-align: center;
}

/* Deloitte logo */
.deloitte-logo {
  height: 36px;
  width: auto;
}

/* ECR Portal heading */
.ecr-title {
  font-size: 36px;
  font-weight: 600;
  color: #0A0A0A;
  margin: 0;
  line-height: 35px;
}

/* Subtitle */
.ecr-subtitle {
  font-size: 24px;
  max-width: 450px;
  width: 100%;
  color: #53565A;
  margin: 0;
  line-height: 35px;
}

/* GitHub brand row */
.github-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.github-brand-text {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

/* Description */
.ecr-description {
  font-size: 14px;
  color: #53565A;
  line-height: 23px;
  font-weight: 400;
  max-width: 400px;
  width: 100%;
  margin: 0;
}

/* Feature checklist */
.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px 20px;
}

.feature-list li {
  font-size: 14px;
  color: #53565A;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 20px;
  font-weight: 600;
}

/* Sign In button */
.sign-in-btn-new {
  background-color: #046A38 !important;
  color: #ffffff !important;
  text-transform: none !important;
  padding: 10px 28px !important;
  border-radius: 4px !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  margin-top: 0.25rem !important;
  box-shadow: 0 2px 6px rgba(0, 166, 81, 0.35) !important;
  transition: background-color 0.2s ease !important;
}

.sign-in-btn-new:hover {
  background-color: #008a43 !important;
}

/* ── Right Panel – Video ────────────────────────────────── */
.login-right-panel {
  width: 58%;
  position: relative;
  overflow: hidden;
  background-color: #000000;
}

.login-showcase-media {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ── Responsive ────────────────────────────────────────── */
@media (max-width: 850px) {
  .login-right-panel {
    display: none;
  }

  .login-left-panel {
    width: 100%;
    padding: 2rem 1.5rem;
  }

  .ecr-subtitle {
    font-size: 18px;
    width: 100%;
    line-height: 26px;
  }

  .ecr-description {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/home.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,uDAAuD;EACvD,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA,8DAA8D;AAC9D;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ── Login Page Layout ────────────────────────────────── */\n.login-page-container {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n}\n\n/* ── Left Panel ────────────────────────────────────────── */\n.login-left-panel {\n  width: 42%;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 3rem;\n}\n\n.login-left-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  max-width: 400px;\n  width: 100%;\n  text-align: center;\n}\n\n/* Deloitte logo */\n.deloitte-logo {\n  height: 36px;\n  width: auto;\n}\n\n/* ECR Portal heading */\n.ecr-title {\n  font-size: 36px;\n  font-weight: 600;\n  color: #0A0A0A;\n  margin: 0;\n  line-height: 35px;\n}\n\n/* Subtitle */\n.ecr-subtitle {\n  font-size: 24px;\n  max-width: 450px;\n  width: 100%;\n  color: #53565A;\n  margin: 0;\n  line-height: 35px;\n}\n\n/* GitHub brand row */\n.github-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.github-brand-text {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n/* Description */\n.ecr-description {\n  font-size: 14px;\n  color: #53565A;\n  line-height: 23px;\n  font-weight: 400;\n  max-width: 400px;\n  width: 100%;\n  margin: 0;\n}\n\n/* Feature checklist */\n.feature-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 6px 20px;\n}\n\n.feature-list li {\n  font-size: 14px;\n  color: #53565A;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  line-height: 20px;\n  font-weight: 600;\n}\n\n/* Sign In button */\n.sign-in-btn-new {\n  background-color: #046A38 !important;\n  color: #ffffff !important;\n  text-transform: none !important;\n  padding: 10px 28px !important;\n  border-radius: 4px !important;\n  font-size: 15px !important;\n  font-weight: 500 !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  margin-top: 0.25rem !important;\n  box-shadow: 0 2px 6px rgba(0, 166, 81, 0.35) !important;\n  transition: background-color 0.2s ease !important;\n}\n\n.sign-in-btn-new:hover {\n  background-color: #008a43 !important;\n}\n\n/* ── Right Panel – Video ────────────────────────────────── */\n.login-right-panel {\n  width: 58%;\n  position: relative;\n  overflow: hidden;\n  background-color: #000000;\n}\n\n.login-showcase-media {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* ── Responsive ────────────────────────────────────────── */\n@media (max-width: 850px) {\n  .login-right-panel {\n    display: none;\n  }\n\n  .login-left-panel {\n    width: 100%;\n    padding: 2rem 1.5rem;\n  }\n\n  .ecr-subtitle {\n    font-size: 18px;\n    width: 100%;\n    line-height: 26px;\n  }\n\n  .ecr-description {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
